/*
 * Copyright (c) 2021 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import React from 'react';

const Terms = () => (
  <div className="rcw-footer">
    <a href="https://www.omnicell.com/privacy" target="_blank" rel="noopener noreferrer">
      Omnicell Privacy Statement
    </a>
    <a
      href="https://enlivenhealth.co/enlivenhealth-website-terms-and-conditions/"
      target="_blank"
      rel="noopener noreferrer"
    >
      EH Terms and Conditions
    </a>
  </div>
);

export default Terms;
